import { AlertTriangle } from "lucide-react";
import { PageHeader } from "./layoutChrome";
import { useAuth } from "@/lib/auth";
import { useWorkspaceMode } from "@/lib/workspaceMode";
import { usePlatformDesigner } from "@/lib/usePlatformDesigner";
import OperationalDataToolsSections from "@/components/dataManagement/OperationalDataToolsSections";
import { useOperationalDataManagement } from "@/lib/useOperationalDataManagement";

export default function GestionDatos() {
  const { user } = useAuth();
  const { mode } = useWorkspaceMode();
  const isPlatformDesigner = usePlatformDesigner();

  const canUse =
    Boolean(user?.is_admin_owner || (user?.is_buyer_tenant && user?.role === "buyer_admin")) &&
    mode !== "distribuidor";

  const dm = useOperationalDataManagement({ enabled: canUse });

  if (!canUse) {
    return (
      <div className="p-6">
        <PageHeader
          title="Gestión de Datos"
          subtitle="Mantenimiento y respaldos de toda la instalación (Visor SAT, Laboral y datos compartidos)."
        />
        <div className="mt-4 bg-amber-50 border border-amber-200 rounded-sm p-4 text-xs text-amber-900 flex gap-2">
          <AlertTriangle className="w-4 h-4 shrink-0 mt-0.5" />
          <p>
            Disponible solo en modo <strong>Despacho</strong> para el titular o administrador del espacio comprador.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6 space-y-6 max-w-4xl">
      <PageHeader
        title={isPlatformDesigner ? "Gestión de Datos" : "Respaldo y recuperación de datos del sistema"}
        subtitle={
          isPlatformDesigner
            ? "Salud del sistema, respaldos unificados de todos los módulos y mantenimiento preventivo"
            : "Consulte la salud del espacio operativo, genere respaldos y restáurelos cuando sea necesario."
        }
      />

      <OperationalDataToolsSections variant="page" dm={dm} showDesignerExtras />
    </div>
  );
}
